export enum TransactionValidationMode {
  DoNothing = 'DoNothing',
  Warn = 'Warn',
  Block = 'Block',
}

export const transactionValidationModeTranslationMap = {
  [TransactionValidationMode.DoNothing]: 'transactionValidationModes.doNothing',
  [TransactionValidationMode.Warn]: 'transactionValidationModes.warn',
  [TransactionValidationMode.Block]: 'transactionValidationModes.block',
};
